import { useState } from 'react';
import { Eye, EyeOff, LogIn, Mail, Lock, Briefcase, MessageSquare, CalendarClock, Star } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { useToast } from '../components/Toast';
import LOGO from '../assets/image.png';

export default function AuthPage() {
  const { login } = useApp();
  const toast = useToast();
  const [showPass, setShowPass] = useState(false);
  const [form, setForm]         = useState({ email: '', password: '' });
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    await new Promise(r => setTimeout(r, 400));
    const ok = login(form.email, form.password);
    setLoading(false);
    if (!ok) setError('Invalid email or password. Please try again.');
  };

  // Feature cards shown on the left panel
  const features = [
    { icon: <Briefcase size={20} />,      label: 'Service Master',  color: '#22c55e' },
    { icon: <MessageSquare size={20} />,  label: 'Enquiries',       color: '#3B82F6' },
    { icon: <CalendarClock size={20} />,  label: 'Demo Schedules',  color: '#8B5CF6' },
    { icon: <Star size={20} />,           label: 'Testimonials',    color: '#F59E0B' },
  ];

  return (
    <div className="auth-page">

      {/* ── Left Panel ── */}
      <div className="auth-left">
        <div className="auth-left-content">

          {/* Logo + Brand */}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16, marginBottom: 40 }}>
            <div style={{
              width: 500, height: 500, borderRadius: 24,
               padding: 10,
              // display: 'flex', alignItems: 'center', justifyContent: 'center',
              // boxShadow: '0 0 0 3px rgba(34,197,94,0.3), 0 8px 32px rgba(0,0,0,0.2)',
              // overflow: 'hidden',
            }}>
              <img src={LOGO} alt="MarketingScapers" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{
                fontFamily: 'var(--font-head)', fontWeight: 800, fontSize: 40,
                color: '#fff', letterSpacing: '-0.3px',
              }}>
                Marketing<span style={{ color: '#22c55e' }}>Scapers</span>
              </div>
              <div style={{ fontSize: 25, color:'#fff' , marginTop: 4, letterSpacing: '0.5px' }}>
                Admin Panel
              </div>
            </div>
          </div>

          {/* Tagline */}
          {/* <p style={{
            color: 'rgba(255,255,255,0.65)', fontSize: 14.5,
            lineHeight: 1.8, fontWeight: 400, textAlign: 'center',
            marginBottom: 36,
          }}>
            Your complete command center for managing services, tracking enquiries, and scheduling demos.
          </p> */}

          {/* Feature cards */}
          {/* <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            {features.map(f => (
              <div key={f.label} style={{
                background: 'rgba(255,255,255,0.06)',
                border: '1px solid rgba(255,255,255,0.09)',
                borderRadius: 12, padding: '14px 16px',
                display: 'flex', alignItems: 'center', gap: 10,
                backdropFilter: 'blur(8px)',
              }}>
                <div style={{
                  width: 34, height: 34, borderRadius: 9,
                  background: `${f.color}20`,
                  border: `1px solid ${f.color}40`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: f.color, flexShrink: 0,
                }}>
                  {f.icon}
                </div>
                <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12.5, fontWeight: 600 }}>
                  {f.label}
                </span>
              </div>
            ))}
          </div> */}

        </div>
      </div>

      {/* ── Right Panel ── */}
      <div className="auth-right">
        <div className="auth-form-wrap">

          {/* Heading */}
          <div style={{ marginBottom: 32 }}>
            <div style={{
              fontFamily: 'var(--font-head)', fontWeight: 800,
              fontSize: 28, color: 'var(--text-primary)', marginBottom: 6,
            }}>
              Welcome to MarketingScapers
            </div>
            <div style={{ fontSize: 14, color: 'var(--text-secondary)', lineHeight: 1.6 }}>
              Sign in to your admin account to continue.
            </div>
          </div>

          {/* Form */}
          <form onSubmit={handleLogin}>

            {/* Email */}
            <div className="form-group">
              <label className="form-label">Email Address</label>
              <div style={{ position: 'relative' }}>
                <Mail size={16} style={{
                  position: 'absolute', left: 13, top: '50%',
                  transform: 'translateY(-50%)', color: 'var(--text-secondary)',
                  pointerEvents: 'none',
                }} />
                <input
                  className="form-input"
                  type="email"
                  placeholder="admin@marketingscapers.com"
                  value={form.email}
                  onChange={e => set('email', e.target.value)}
                  required
                  style={{ paddingLeft: 38 }}
                />
              </div>
            </div>

            {/* Password */}
            <div className="form-group">
              <label className="form-label">Password</label>
              <div style={{ position: 'relative' }}>
                <Lock size={16} style={{
                  position: 'absolute', left: 13, top: '50%',
                  transform: 'translateY(-50%)', color: 'var(--text-secondary)',
                  pointerEvents: 'none',
                }} />
                <input
                  className="form-input"
                  type={showPass ? 'text' : 'password'}
                  placeholder="Enter your password"
                  value={form.password}
                  onChange={e => set('password', e.target.value)}
                  required
                  style={{ paddingLeft: 38, paddingRight: 44 }}
                />
                <span
                  onClick={() => setShowPass(v => !v)}
                  style={{
                    position: 'absolute', right: 13, top: '50%',
                    transform: 'translateY(-50%)', cursor: 'pointer',
                    color: 'var(--text-secondary)',
                  }}
                >
                  {showPass ? <EyeOff size={16} /> : <Eye size={16} />}
                </span>
              </div>
            </div>

            {/* Error */}
            {error && (
              <div style={{
                fontSize: 13, marginBottom: 16, padding: '10px 14px',
                background: '#FEE2E2', color: '#DC2626',
                borderRadius: 8, border: '1px solid #FECACA',
              }}>
                {error}
              </div>
            )}

            {/* Sign In button */}
            <button
              type="submit"
              disabled={loading}
              className="auth-signin-btn"
            >
              {loading ? (
                <span style={{ display: 'flex', alignItems: 'center', gap: 8, justifyContent: 'center' }}>
                  <span className="auth-spinner" />
                  Signing in...
                </span>
              ) : (
                <span style={{ display: 'flex', alignItems: 'center', gap: 8, justifyContent: 'center' }}>
                  <LogIn size={17} />
                  Sign In
                </span>
              )}
            </button>

          </form>
        </div>
      </div>

    </div>
  );
}
